/**
 * @file useRegionClick
 */
import { getElementBoundary } from '@tencent/glue-dom-boundary';
import { useCallback, useRef } from 'react';
import { useRegionInstance } from '../context/reigon';
export function useRegionClick() {
  var region = useRegionInstance();
  var elem = useRef(null);
  var onClick = useCallback(function (e) {
    var el = elem.current;

    if (el == null) {
      return;
    }

    var offset = getElementBoundary(el);
    var x = e.clientX - offset.left;
    var y = e.clientY - offset.top;
    var point = region.getPointByOffset({
      x: x,
      y: y
    });

    if (point.getDragging()) {
      point.setDragging(false);
    }

    point.updateRealOffset(point.getOffset(), {
      x: x,
      y: y
    });
  }, []);
  return [elem, onClick];
}